/** Phase: myPage gaps, travelProfile, penaltyRecovery, wallet, dashboard shell/tabs — ko/en/vi/ru */

export const phaseMyPageDashboardKo = {
  common: {
    comingSoon: '준비 중',
    saving: '저장 중…',
  },
  myPage: {
    menu: {
      travelProfile: '여행자 정보',
    },
  },
  travelProfile: {
    title: '여행자 정보',
    introTitle: '여행자 정보 입력',
    introSubtitle: '안전한 여행을 위해\n아래 정보가 필요해요',
    formSubtitle: '한번 입력해두면 예약 시 자동으로 불러와요',
    startCta: '정보 입력하기',
    completeBadge: '정보 입력 완료',
    save: '저장하기',
    loadFailed: '불러오기 실패',
    saveSuccess: '여행자 정보가 저장됐어요',
    saveFailed: '저장 실패',
  },
  travelProfileIntro: {
    insuranceTitle: '여행자보험 가입',
    insuranceDesc: '여행사에서 단체로 여행자보험에 가입해드려요. 추가 비용 없어요.',
    pickupTitle: '픽업 서비스',
    pickupDesc: '가이드/기사가 공항에서 손님을 찾기 위해 호텔 정보가 필요해요.',
    assignTitle: '담당자 배정',
    assignDesc: '출발 전 가이드/기사 정보를 안내드려요.',
    privacyTitle: '개인정보 보호',
    privacyDesc: '입력하신 정보는 여행 목적으로만 사용되며 여행 종료 후 파기됩니다.',
  },
  travelProfileFields: {
    nameKr: '한글 성명',
    nameKrPh: '예: 홍길동',
    passportName: '영문 성명 (여권과 동일)',
    passportNamePh: '예: HONG GIL DONG',
    passportNameHint: '가이드 피켓에 표시될 이름',
    birthDate: '생년월일',
    ageYears: '만 {age}세',
    gender: '성별',
    genderMale: '남',
    genderFemale: '여',
    contact: '연락처',
    contactPh: '예: 010-1234-5678',
    email: '이메일',
    emailPh: '예: hong@email.com',
    emailHint: '보험 증권을 받으실 수 있어요',
    nationality: '국적',
    emergencyContact: '긴급 연락처',
    emergencyContactPh: '예: 010-9876-5432',
    emergencyContactHint: '현지 긴급 상황 시 연락처',
    passportNo: '여권 번호',
    passportNoPh: '예: M12345678',
    passportNoHint: '여행자보험 가입에 사용돼요. 보험 가입 후 즉시 파기됩니다.',
    passportExpiry: '여권 만료일',
    passportExpiryHint: '출발일 기준 6개월 이상 남아있어야 해요',
    allergy: '알레르기',
    allergyPh: '예: 견과류, 갑각류',
  },
  travelProfileErrors: {
    passportNameRequired: '영문 성명을 입력해 주세요',
    birthDateRequired: '생년월일을 입력해 주세요',
    genderRequired: '성별을 선택해 주세요',
    contactRequired: '연락처를 입력해 주세요',
    passportNoRequired: '여권 번호를 입력해 주세요',
    passportExpiryRequired: '여권 만료일을 입력해 주세요',
    passportExpirySoon: '여권 만료일이 6개월 이내예요!',
  },
  wallet: {
    comingSoon: '준비 중',
    holdLabel: '보류',
  },
  penaltyRecovery: {
    title: '노쇼 회복 센터',
    statusLabel: '현재 제재 상태',
    statusSummary: '노쇼 {count}회 · {mode}',
    modeMissionOnly: '미션 회복만 가능',
    modeChoice: '회복 방법 선택 가능',
    tabAuto: '자동해제',
    tabMission: '미션완료',
    tabPoints: '밍고포인트',
    autoTitle: '자동해제',
    autoDaysLeft: '남은 제재 기간: {days}일',
    autoHint: '시간 경과 후 자동으로 정상 상태로 전환됩니다.',
    missionTitle: '미션완료',
    missionProgress: '진행률 {rate}%',
    missionWrite: '글쓰기 완료',
    missionTrade: '안전거래 1회',
    missionReview: '리뷰 작성',
    missionEvent: '이벤트 참여',
    statusDone: '완료',
    statusPending: '대기',
    pointsTitle: '밍고포인트 회복',
    pointsBlocked: '노쇼 5회 이상은 포인트 회복이 불가능합니다.',
    pointsNeeded: '필요 포인트: {points} P',
    pointsPay: '회복 결제하기',
  },
  dashboard: {
    tabListAria: '업체 대시보드',
    emptyRegisterLead: '등록된 업체가 없어요. 지금 등록해 보세요.',
    quickRegisterCta: '🚀 30초 빠른 등록',
    categoryRegisterCta: '📋 카테고리별 상세 등록',
    listLoading: '불러오는 중…',
    listEmpty: '등록된 업체가 없어요',
    listRegisterCta: '업체 등록하기',
    listAddBusiness: '+ 새 업체 등록',
    welcomeTitle: '🎉 등록 완료!',
    welcomeLead: '업체가 등록되었어요. 프로필을 채울수록 더 많이 노출돼요.',
    welcomeCta: '프로필 강화하기',
    subBackMore: '<',
    cancelDeletionSuccess: '탈퇴 요청을 취소했어요.',
    cancelDeletionFailed: '취소 실패',
    tabs: {
      home: '홈',
      bookings: '예약',
      bookingsManage: '예약관리',
      chat: '채팅',
      catalog: '상품',
      tourCatalog: '투어/패키지',
      services: '서비스',
      more: '더보기',
      roomsManage: '객실관리',
      menuManage: '메뉴관리',
      productManage: '상품관리',
      orders: '주문조회',
      propertiesManage: '매물관리',
      consultations: '상담이력',
      patientsManage: '고객관리',
      constructionShowcases: '시공사례',
      quoteInquiries: '견적문의',
      classesManage: '수업관리',
      studentsManage: '학생관리',
      schedule: '일정',
      consultation: '상담',
      portfolio: '포트폴리오',
      collabInquiries: '협업문의',
      jobsManage: '공고관리',
      applicants: '지원자',
    },
    industry: {
      travel: '여행·투어',
      lodging: '호텔·스테이',
      food: '음식·카페',
      realestate: '부동산·임대',
      medical: '의료/건강/미용',
      home_interior: '홈/인테리어',
      education: '교육/레슨',
      mobility: '모빌리티/이사/용달',
      finance: '금융/송금',
      wedding: '웨딩/이벤트',
      pet: '반려동물',
      creator: '크리에이터/미디어',
      childcare: '육아/돌봄',
      jobs: '일/비즈니스',
    },
  },
};

export const phaseMyPageDashboardEn = {
  common: {
    comingSoon: 'Coming soon',
    saving: 'Saving…',
  },
  myPage: {
    menu: {
      travelProfile: 'Traveler profile',
    },
  },
  travelProfile: {
    title: 'Traveler profile',
    introTitle: 'Traveler information',
    introSubtitle: 'For a safe trip,\nwe need the details below',
    formSubtitle: 'Enter once — we’ll auto-fill when you book',
    startCta: 'Enter details',
    completeBadge: 'Profile complete',
    save: 'Save',
    loadFailed: 'Could not load',
    saveSuccess: 'Traveler profile saved',
    saveFailed: 'Could not save',
  },
  travelProfileIntro: {
    insuranceTitle: 'Travel insurance',
    insuranceDesc: 'Your agency enrolls you in group travel insurance at no extra cost.',
    pickupTitle: 'Airport pickup',
    pickupDesc: 'Guides and drivers need your hotel info to meet you at the airport.',
    assignTitle: 'Assigned coordinator',
    assignDesc: 'We’ll share your guide or driver details before departure.',
    privacyTitle: 'Privacy',
    privacyDesc: 'Your data is used only for the trip and deleted after travel ends.',
  },
  travelProfileFields: {
    nameKr: 'Name (Korean)',
    nameKrPh: 'e.g. Hong Gildong',
    passportName: 'Name on passport (English)',
    passportNamePh: 'e.g. HONG GIL DONG',
    passportNameHint: 'Shown on guide pickup sign',
    birthDate: 'Date of birth',
    ageYears: 'Age {age}',
    gender: 'Gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    contact: 'Phone',
    contactPh: 'e.g. 010-1234-5678',
    email: 'Email',
    emailPh: 'e.g. hong@email.com',
    emailHint: 'Insurance policy can be sent here',
    nationality: 'Nationality',
    emergencyContact: 'Emergency contact',
    emergencyContactPh: 'e.g. 010-9876-5432',
    emergencyContactHint: 'Local emergency contact',
    passportNo: 'Passport number',
    passportNoPh: 'e.g. M12345678',
    passportNoHint: 'Used for travel insurance; destroyed right after enrollment.',
    passportExpiry: 'Passport expiry',
    passportExpiryHint: 'Must be valid 6+ months from departure',
    allergy: 'Allergies',
    allergyPh: 'e.g. nuts, shellfish',
  },
  travelProfileErrors: {
    passportNameRequired: 'Enter your name as on passport',
    birthDateRequired: 'Enter date of birth',
    genderRequired: 'Select gender',
    contactRequired: 'Enter phone number',
    passportNoRequired: 'Enter passport number',
    passportExpiryRequired: 'Enter passport expiry date',
    passportExpirySoon: 'Passport expires within 6 months!',
  },
  wallet: {
    comingSoon: 'Coming soon',
    holdLabel: 'On hold',
  },
  penaltyRecovery: {
    title: 'No-show recovery',
    statusLabel: 'Current restriction',
    statusSummary: 'No-shows: {count} · {mode}',
    modeMissionOnly: 'Mission recovery only',
    modeChoice: 'Choose a recovery option',
    tabAuto: 'Auto lift',
    tabMission: 'Missions',
    tabPoints: 'Mingo points',
    autoTitle: 'Automatic lift',
    autoDaysLeft: 'Days remaining: {days}',
    autoHint: 'Your account returns to normal when the period ends.',
    missionTitle: 'Complete missions',
    missionProgress: 'Progress {rate}%',
    missionWrite: 'Post in community',
    missionTrade: 'One safe trade',
    missionReview: 'Write a review',
    missionEvent: 'Join an event',
    statusDone: 'Done',
    statusPending: 'Pending',
    pointsTitle: 'Recover with points',
    pointsBlocked: 'Point recovery is unavailable after 5 no-shows.',
    pointsNeeded: 'Points required: {points} P',
    pointsPay: 'Pay to recover',
  },
  dashboard: {
    tabListAria: 'Business dashboard',
    emptyRegisterLead: 'No business listed yet. Register now.',
    quickRegisterCta: '🚀 Quick register (30 sec)',
    categoryRegisterCta: '📋 Register by category',
    listLoading: 'Loading…',
    listEmpty: 'No businesses yet',
    listRegisterCta: 'Register business',
    listAddBusiness: '+ Add another business',
    welcomeTitle: '🎉 Registration complete!',
    welcomeLead: 'Your business is live. A fuller profile gets more visibility.',
    welcomeCta: 'Improve profile',
    subBackMore: '<',
    cancelDeletionSuccess: 'Deletion request cancelled.',
    cancelDeletionFailed: 'Could not cancel',
    tabs: {
      home: 'Home',
      bookings: 'Bookings',
      bookingsManage: 'Bookings',
      chat: 'Chat',
      catalog: 'Products',
      tourCatalog: 'Tours & packages',
      services: 'Services',
      more: 'More',
      roomsManage: 'Rooms',
      menuManage: 'Menu',
      productManage: 'Products',
      orders: 'Orders',
      propertiesManage: 'Listings',
      consultations: 'Consultations',
      patientsManage: 'Clients',
      constructionShowcases: 'Projects',
      quoteInquiries: 'Quote requests',
      classesManage: 'Classes',
      studentsManage: 'Students',
      schedule: 'Schedule',
      consultation: 'Consult',
      portfolio: 'Portfolio',
      collabInquiries: 'Collab requests',
      jobsManage: 'Job posts',
      applicants: 'Applicants',
    },
    industry: {
      travel: 'Travel & tours',
      lodging: 'Hotels & stays',
      food: 'Food & cafés',
      realestate: 'Real estate & rent',
      medical: 'Medical & beauty',
      home_interior: 'Home & interior',
      education: 'Education & lessons',
      mobility: 'Moving & delivery',
      finance: 'Finance & remittance',
      wedding: 'Wedding & events',
      pet: 'Pets',
      creator: 'Creator & media',
      childcare: 'Childcare',
      jobs: 'Jobs & business',
    },
  },
};

export const phaseMyPageDashboardVi = {
  common: {
    comingSoon: 'Sắp ra mắt',
    saving: 'Đang lưu…',
  },
  myPage: {
    menu: {
      travelProfile: 'Thông tin du lịch',
    },
  },
  travelProfile: {
    title: 'Thông tin du lịch',
    introTitle: 'Nhập thông tin du lịch',
    introSubtitle: 'Để chuyến đi an toàn,\nchúng tôi cần các thông tin sau',
    formSubtitle: 'Nhập một lần — tự động điền khi đặt chỗ',
    startCta: 'Nhập thông tin',
    completeBadge: 'Đã hoàn tất hồ sơ',
    save: 'Lưu',
    loadFailed: 'Không tải được',
    saveSuccess: 'Đã lưu thông tin du lịch',
    saveFailed: 'Không lưu được',
  },
  travelProfileIntro: {
    insuranceTitle: 'Bảo hiểm du lịch',
    insuranceDesc: 'Công ty lữ hành đăng ký bảo hiểm nhóm, không phí thêm.',
    pickupTitle: 'Đón sân bay',
    pickupDesc: 'Hướng dẫn viên/tài xế cần thông tin khách sạn để đón bạn.',
    assignTitle: 'Phân công phụ trách',
    assignDesc: 'Chúng tôi gửi thông tin hướng dẫn/tài xế trước khi khởi hành.',
    privacyTitle: 'Bảo mật',
    privacyDesc: 'Dữ liệu chỉ dùng cho chuyến đi và xóa sau khi kết thúc.',
  },
  travelProfileFields: {
    nameKr: 'Họ tên (tiếng Hàn)',
    nameKrPh: 'vd: Hong Gildong',
    passportName: 'Họ tên hộ chiếu (tiếng Anh)',
    passportNamePh: 'vd: HONG GIL DONG',
    passportNameHint: 'Hiển thị trên biển đón',
    birthDate: 'Ngày sinh',
    ageYears: '{age} tuổi',
    gender: 'Giới tính',
    genderMale: 'Nam',
    genderFemale: 'Nữ',
    contact: 'Điện thoại',
    contactPh: 'vd: 010-1234-5678',
    email: 'Email',
    emailPh: 'vd: hong@email.com',
    emailHint: 'Có thể nhận giấy chứng nhận bảo hiểm',
    nationality: 'Quốc tịch',
    emergencyContact: 'Liên hệ khẩn',
    emergencyContactPh: 'vd: 010-9876-5432',
    emergencyContactHint: 'Liên hệ khi khẩn cấp tại địa phương',
    passportNo: 'Số hộ chiếu',
    passportNoPh: 'vd: M12345678',
    passportNoHint: 'Dùng cho bảo hiểm; hủy ngay sau khi đăng ký.',
    passportExpiry: 'Hạn hộ chiếu',
    passportExpiryHint: 'Còn hạn ít nhất 6 tháng từ ngày khởi hành',
    allergy: 'Dị ứng',
    allergyPh: 'vd: hạt, hải sản',
  },
  travelProfileErrors: {
    passportNameRequired: 'Nhập họ tên trên hộ chiếu',
    birthDateRequired: 'Nhập ngày sinh',
    genderRequired: 'Chọn giới tính',
    contactRequired: 'Nhập số điện thoại',
    passportNoRequired: 'Nhập số hộ chiếu',
    passportExpiryRequired: 'Nhập hạn hộ chiếu',
    passportExpirySoon: 'Hộ chiếu hết hạn trong 6 tháng!',
  },
  wallet: {
    comingSoon: 'Sắp ra mắt',
    holdLabel: 'Tạm giữ',
  },
  penaltyRecovery: {
    title: 'Khôi phục sau no-show',
    statusLabel: 'Trạng thái hạn chế',
    statusSummary: 'No-show {count} lần · {mode}',
    modeMissionOnly: 'Chỉ khôi phục bằng nhiệm vụ',
    modeChoice: 'Chọn cách khôi phục',
    tabAuto: 'Tự động',
    tabMission: 'Nhiệm vụ',
    tabPoints: 'Điểm Mingo',
    autoTitle: 'Tự động gỡ hạn chế',
    autoDaysLeft: 'Còn {days} ngày',
    autoHint: 'Tài khoản sẽ bình thường khi hết thời hạn.',
    missionTitle: 'Hoàn thành nhiệm vụ',
    missionProgress: 'Tiến độ {rate}%',
    missionWrite: 'Đăng bài cộng đồng',
    missionTrade: 'Giao dịch an toàn 1 lần',
    missionReview: 'Viết đánh giá',
    missionEvent: 'Tham gia sự kiện',
    statusDone: 'Xong',
    statusPending: 'Chờ',
    pointsTitle: 'Khôi phục bằng điểm',
    pointsBlocked: 'Không thể dùng điểm sau 5 lần no-show.',
    pointsNeeded: 'Cần {points} P',
    pointsPay: 'Thanh toán khôi phục',
  },
  dashboard: {
    tabListAria: 'Bảng điều khiển doanh nghiệp',
    emptyRegisterLead: 'Vui lòng đăng ký cửa hàng trước khi sử dụng.',
    quickRegisterCta: '🚀 Đăng ký nhanh 30 giây',
    categoryRegisterCta: '📋 Đăng ký theo danh mục',
    listLoading: 'Đang tải…',
    listEmpty: 'Chưa có doanh nghiệp',
    listRegisterCta: 'Đăng ký doanh nghiệp',
    listAddBusiness: '+ Thêm doanh nghiệp',
    welcomeTitle: '🎉 Đăng ký xong!',
    welcomeLead: 'Doanh nghiệp đã được tạo. Hồ sơ đầy đủ sẽ được hiển thị nhiều hơn.',
    welcomeCta: 'Hoàn thiện hồ sơ',
    subBackMore: '<',
    cancelDeletionSuccess: 'Đã hủy yêu cầu xóa.',
    cancelDeletionFailed: 'Không hủy được',
    tabs: {
      home: 'Trang chủ',
      bookings: 'Đặt chỗ',
      bookingsManage: 'Quản lý đặt chỗ',
      chat: 'Chat',
      catalog: 'Sản phẩm',
      tourCatalog: 'Tour & gói',
      services: 'Dịch vụ',
      more: 'Thêm',
      roomsManage: 'Phòng',
      menuManage: 'Thực đơn',
      productManage: 'Sản phẩm',
      orders: 'Đơn hàng',
      propertiesManage: 'Bất động sản',
      consultations: 'Tư vấn',
      patientsManage: 'Khách hàng',
      constructionShowcases: 'Công trình',
      quoteInquiries: 'Yêu cầu báo giá',
      classesManage: 'Lớp học',
      studentsManage: 'Học viên',
      schedule: 'Lịch',
      consultation: 'Tư vấn',
      portfolio: 'Portfolio',
      collabInquiries: 'Hợp tác',
      jobsManage: 'Tuyển dụng',
      applicants: 'Ứng viên',
    },
    industry: {
      travel: 'Du lịch & tour',
      lodging: 'Khách sạn & lưu trú',
      food: 'Ẩm thực & cà phê',
      realestate: 'Bất động sản',
      medical: 'Y tế & làm đẹp',
      home_interior: 'Nhà & nội thất',
      education: 'Giáo dục',
      mobility: 'Vận chuyển & chuyển nhà',
      finance: 'Tài chính & chuyển tiền',
      wedding: 'Cưới & sự kiện',
      pet: 'Thú cưng',
      creator: 'Sáng tạo & media',
      childcare: 'Chăm sóc trẻ',
      jobs: 'Việc làm',
    },
  },
};

export const phaseMyPageDashboardRu = {
  common: {
    comingSoon: 'Скоро',
    saving: 'Сохранение…',
  },
  myPage: {
    menu: {
      travelProfile: 'Данные путешественника',
    },
  },
  travelProfile: {
    title: 'Данные путешественника',
    introTitle: 'Информация для поездки',
    introSubtitle: 'Для безопасной поездки\nнужны данные ниже',
    formSubtitle: 'Введите один раз — подставим при бронировании',
    startCta: 'Ввести данные',
    completeBadge: 'Профиль заполнен',
    save: 'Сохранить',
    loadFailed: 'Не удалось загрузить',
    saveSuccess: 'Данные путешественника сохранены',
    saveFailed: 'Не удалось сохранить',
  },
  travelProfileIntro: {
    insuranceTitle: 'Страховка путешественника',
    insuranceDesc: 'Агентство оформляет групповую страховку без доплаты.',
    pickupTitle: 'Встреча в аэропорту',
    pickupDesc: 'Гиду/водителю нужен отель, чтобы встретить вас.',
    assignTitle: 'Назначенный координатор',
    assignDesc: 'Данные гида/водителя перед выездом.',
    privacyTitle: 'Конфиденциальность',
    privacyDesc: 'Данные только для поездки и удаляются после неё.',
  },
  travelProfileFields: {
    nameKr: 'Имя (корейск.)',
    nameKrPh: 'напр. Hong Gildong',
    passportName: 'Имя в паспорте (латиница)',
    passportNamePh: 'напр. HONG GIL DONG',
    passportNameHint: 'На табличке встречи',
    birthDate: 'Дата рождения',
    ageYears: '{age} лет',
    gender: 'Пол',
    genderMale: 'М',
    genderFemale: 'Ж',
    contact: 'Телефон',
    contactPh: 'напр. 010-1234-5678',
    email: 'Email',
    emailPh: 'напр. hong@email.com',
    emailHint: 'Сюда можно отправить полис',
    nationality: 'Гражданство',
    emergencyContact: 'Экстренный контакт',
    emergencyContactPh: 'напр. 010-9876-5432',
    emergencyContactHint: 'Контакт на месте в экстренной ситуации',
    passportNo: 'Номер паспорта',
    passportNoPh: 'напр. M12345678',
    passportNoHint: 'Для страховки; уничтожается после оформления.',
    passportExpiry: 'Срок паспорта',
    passportExpiryHint: 'Не менее 6 месяцев от даты выезда',
    allergy: 'Аллергии',
    allergyPh: 'напр. орехи, морепродукты',
  },
  travelProfileErrors: {
    passportNameRequired: 'Введите имя как в паспорте',
    birthDateRequired: 'Введите дату рождения',
    genderRequired: 'Выберите пол',
    contactRequired: 'Введите телефон',
    passportNoRequired: 'Введите номер паспорта',
    passportExpiryRequired: 'Введите срок паспорта',
    passportExpirySoon: 'Паспорт истекает в течение 6 месяцев!',
  },
  wallet: {
    comingSoon: 'Скоро',
    holdLabel: 'Заморожено',
  },
  penaltyRecovery: {
    title: 'Восстановление после no-show',
    statusLabel: 'Текущее ограничение',
    statusSummary: 'No-show: {count} · {mode}',
    modeMissionOnly: 'Только через миссии',
    modeChoice: 'Выберите способ восстановления',
    tabAuto: 'Автоснятие',
    tabMission: 'Миссии',
    tabPoints: 'Очки Mingo',
    autoTitle: 'Автоматическое снятие',
    autoDaysLeft: 'Осталось дней: {days}',
    autoHint: 'Ограничение снимется по истечении срока.',
    missionTitle: 'Выполните миссии',
    missionProgress: 'Прогресс {rate}%',
    missionWrite: 'Пост в сообществе',
    missionTrade: 'Одна безопасная сделка',
    missionReview: 'Написать отзыв',
    missionEvent: 'Участие в событии',
    statusDone: 'Готово',
    statusPending: 'Ожидание',
    pointsTitle: 'Восстановление за очки',
    pointsBlocked: 'После 5 no-show очки недоступны.',
    pointsNeeded: 'Нужно очков: {points} P',
    pointsPay: 'Оплатить восстановление',
  },
  dashboard: {
    tabListAria: 'Панель бизнеса',
    emptyRegisterLead: 'Зарегистрируйте заведение, чтобы продолжить.',
    quickRegisterCta: '🚀 Быстрая регистрация (30 сек)',
    categoryRegisterCta: '📋 Регистрация по категории',
    listLoading: 'Загрузка…',
    listEmpty: 'Нет бизнесов',
    listRegisterCta: 'Зарегистрировать бизнес',
    listAddBusiness: '+ Добавить бизнес',
    welcomeTitle: '🎉 Регистрация завершена!',
    welcomeLead: 'Бизнес создан. Полный профиль — больше показов.',
    welcomeCta: 'Улучшить профиль',
    subBackMore: '<',
    cancelDeletionSuccess: 'Запрос на удаление отменён.',
    cancelDeletionFailed: 'Не удалось отменить',
    tabs: {
      home: 'Главная',
      bookings: 'Брони',
      bookingsManage: 'Бронирования',
      chat: 'Чат',
      catalog: 'Товары',
      tourCatalog: 'Туры и пакеты',
      services: 'Услуги',
      more: 'Ещё',
      roomsManage: 'Номера',
      menuManage: 'Меню',
      productManage: 'Товары',
      orders: 'Заказы',
      propertiesManage: 'Объекты',
      consultations: 'Консультации',
      patientsManage: 'Клиенты',
      constructionShowcases: 'Проекты',
      quoteInquiries: 'Запросы цен',
      classesManage: 'Занятия',
      studentsManage: 'Ученики',
      schedule: 'Расписание',
      consultation: 'Консультация',
      portfolio: 'Портфолио',
      collabInquiries: 'Коллаборации',
      jobsManage: 'Вакансии',
      applicants: 'Кандидаты',
    },
    industry: {
      travel: 'Путешествия и туры',
      lodging: 'Отели и проживание',
      food: 'Еда и кафе',
      realestate: 'Недвижимость',
      medical: 'Медицина и красота',
      home_interior: 'Дом и интерьер',
      education: 'Образование',
      mobility: 'Переезды и доставка',
      finance: 'Финансы и переводы',
      wedding: 'Свадьбы и события',
      pet: 'Питомцы',
      creator: 'Креаторы и медиа',
      childcare: 'Уход за детьми',
      jobs: 'Работа и бизнес',
    },
  },
};
